'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PushPin = require('./PushPin');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PushPin).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/PushPin/index.js
// module id = 1262
// module chunks = 1